import React, { useCallback, useEffect, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import { Card } from 'react-bootstrap';
import api from '../../../../api';
import './EventPersonnelList.scss';
import CreateNewPerson from '../CreateNewPerson/CreateNewPerson';
import EventPersonnelListItem from './EventPersonnelListItem/EventPersonnelListItem';
import { NavLink } from 'react-router-dom';
import LoadingOverlay from '../../../common/LoadingOverlay';
import Pagination from '../../../common/Pagination';
import { useTranslation } from 'react-i18next';
import { toastrAdd } from '../../../../actions';
// import usePersonsMeta from '../../../../hooks/usePersonsMeta';

const initialState = {
    persons: [],
    personsTotal: 0,
    loading: true,
    pageCount: 0,
    params: {
        page: 1,
        limit: 25,
        sorter: { column: 'timeModified', direction: 'desc' },
        search: null,
        searchColumns: [
            { column: 'firstNames' },
            { column: 'lastName' },
            { column: 'email' }
        ]
    }
};

const reducer = (state, action) => {
    switch(action.type) {
        case 'LOADING':
            return {
                ...state,
                loading: action.loading
            };
        case 'SET_PERSONS':
            return {
                ...state,
                persons: action.persons,
                pageCount: action.pageCount,
                loading: false
            };
        case 'SET_PARAMS':
            return {
                ...state,
                params: action.params
            };
        default:
            return state;
    };
};

function EventPersonnelList(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { eventID, create, limit } = props;
    const partnerID = localStorage.getItem("partnerID");
    //const [ statuses ] = usePersonsMeta();
    const [ state, stateDispatch ] = useReducer(reducer, {
        ...initialState,
        params: {
            ...initialState.params,
            limit
        }
    });
    const { persons, personsTotal, loading, params, pageCount } = state;
    const sortingOptions = [
        { value: '{ "column": "timeModified", "direction": "desc" }', text: `${t('general.modified')} ↓`},
        { value: '{ "column": "timeModified", "direction": "asc " }', text: `${t('general.modified')} ↑`},
        { value: '{ "column": "firstNames", "direction": "asc" }', text: `${t('general.first_name')} (A-Z)`},
        { value: '{ "column": "firstNames", "direction": "desc" }', text: `${t('general.first_name')} (Z-A)`},
        { value: '{ "column": "lastName", "direction": "asc" }', text: `${t('general.last_name')} (A-Z)`},
        { value: '{ "column": "lastName", "direction": "desc" }', text: `${t('general.last_name')} (Z-A)`},
    ];

    /**
     * Fetch event personnel.
     */
    const _fetchEventPersons = useCallback((params) => {
        stateDispatch({ type: 'LOADING', loading: true });

        api.person.getEventPersonnel(eventID, partnerID, params)
            .then(response => {
                stateDispatch({
                    type: 'SET_PERSONS',
                    persons: response.data.data.persons,
                    personsTotal: response.data.meta.rowsTotal,
                    pageCount: Math.ceil(response.data.meta.rowsTotal / response.data.meta.limit)
                });
            })
            .catch((error) => {
                stateDispatch({ type: 'LOADING', loading: false });
                dispatch(toastrAdd({code: 0, details: `${t('general.details')}: ${error.errors[0].details}`, title: `${error.errors[0].title}`, type: 'error'}));
            });
    }, [eventID, partnerID, dispatch, t]);

    /**
     * Fetch event personnel on component mount and on params change.
     */
    useEffect(() => {
        _fetchEventPersons(params)
    }, [_fetchEventPersons, params]);

    const deletePerson = (person) => {
        const ids = {
            eventID,
            partnerID: localStorage.getItem('partnerID'),
            personID: person.personID
        };

		api.person.deleteEventPerson(ids)
			.then(() => {
                const currentPersons = persons.length - 1;
                let updatedParams = { ...params };

                if (currentPersons === 0) {
                    updatedParams = {
                        ...updatedParams,
                        page: params.page !== 1 ? params.page - 1 : params.page
                    };
                }

                stateDispatch({ type: 'SET_PARAMS', params: updatedParams });
            })
			.catch((error) => {
				_fetchEventPersons(params);
                dispatch(toastrAdd({code: 0, details: `${t('general.details')}: ${error.errors[0].details}`, title: `${error.errors[0].title}`, type: 'error'}));
			});
	};

    const handlePageSize = ({ target }) => {
        stateDispatch({ type: 'SET_PARAMS', params: {
            ...params,
            page: 1,
            limit: target.value
        }});
    };

    const handleSearch = ({ target }) => {
        stateDispatch({ type: 'SET_PARAMS', params: {
            ...params,
            page: 1,
            search: target.value.split(' ') || null
        }});
    };

    const handleSorting = ({ target }) => {
        stateDispatch({ type: 'SET_PARAMS', params: {
            ...params,
            sorter: JSON.parse(target.value)
        }});
    };

    const paginate = ({ selected }) => {
        stateDispatch({ type: 'SET_PARAMS', params: {
            ...params,
            page: selected + 1
        }});
    };

    const listCallBack = () => {
        _fetchEventPersons(state.params);
    };

    return (
        <Card className="mt-0">
            {/* create ?
                <Card.Header>
                    <CreateNewPerson callback={listCallBack} />
                    Henkilöstö
                    <span className="pull-right" style={{ display: 'inline-block', marginLeft: 5 }}>
                        <select
                            className="form-control form-control-sm"
                            defaultValue={25}
                            onChange={handlePageSize}
                        >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </span>
                    <span className="pull-right" style={{ display: 'inline-block', marginLeft: 5 }}>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Etsi"
                            onChange={handleSearch}
                        />
                    </span>
                    <span className="pull-right" style={{ display: 'inline-block', marginLeft: 5 }}>
                        <select
                            className="form-control form-control-sm"
                            defaultValue={{ column: 'timeModified', direction: 'desc' }}
                            onChange={handleSorting}
                        >
                            {sortingOptions.map((o, i) => (
                                <option
                                    key={i}
                                    value={o.value}
                                >
                                    {o.text}
                                </option>
                            ))}
                        </select>
                    </span>
                </Card.Header>
                :
                <Card.Header>
                    Henkilöstö
                    <NavLink to={`${eventID}/personnel`} className="btn btn-link btn-sm float-right">Hallitse henkilöstöä</NavLink>
                </Card.Header>
             */}
            {create ?
                <Card.Header>
                    <div className="d-flex">
                        <div>
                            {t('persons.browse_personnel')}
                            <span className="d-block text-muted" style={{ fontSize: 14 }}>{t('persons.browse_representatives_subtitle')}</span>
                        </div>
                        {eventID !== '0c01107f-e93d-11ea-a21a-ee6a04371b85' ?
                            <div className="ml-auto">
                                <CreateNewPerson
                                    callback={listCallBack}
                                    eventID={eventID}
                                />
                            </div>
                        : null}
                    </div>
                </Card.Header>
                :
                <Card.Header>
                    {t('events.personnel')}
                    <NavLink to={`${eventID}/people`} className="btn btn-link btn-sm float-right">{t('persons.manage_personnel')}</NavLink>
                </Card.Header>
            }

            {create ?
                <div className="container DataListInputs">
                    <div className="row justify-content align-items-center">
                        <div className="col col-sm-auto">
                            <select
                                className="form-control form-control-sm"
                                defaultValue={25}
                                onChange={handlePageSize}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div className="col col-sm-auto">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder={t('general.search')}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="col col-sm-auto">
                            <select
                                className="form-control form-control-sm"
                                defaultValue={{ column: 'timeModified', direction: 'desc' }}
                                onChange={handleSorting}
                            >
                                {sortingOptions.map((o, i) => (
                                    <option
                                        key={i}
                                        value={o.value}
                                    >
                                        {o.text}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            : null}

            <div className="DataList">
                {persons.map(person => (
                    <EventPersonnelListItem
                        key={person.personID}
                        person={person}
                        callback={listCallBack}
                        deletePerson={deletePerson}
                        eventID={eventID}
                        //statuses={statuses}
                    />
                ))}
                {loading ?
                    <LoadingOverlay />
                : null}
            </div>

            {persons.length ?
                <Card.Footer>
                    <div className="pull-right">
                        <Pagination 
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={paginate}
                            forcePage={params.page - 1}
                        />
                    </div>
                </Card.Footer>
            : null}
            {!persons.length ?
                <Card.Body>
                    {personsTotal > 0 || create
                        ?
                            <>{t('persons.no_personnel')}</>
                        : 
                            <>{t('persons.no_personnel_helper1')} <NavLink to={`/events/${eventID}/people`}>{t('persons.no_personnel_helper2')}</NavLink>.</>
                    }
                </Card.Body>
            : null}
        </Card>
    );
}

export default EventPersonnelList;